export default __webpack_public_path__ + "images/1ad838511aff1fada5f510fbdc47fd10-do_2.png";